import { ShieldCheck, Clock, Tag, Award } from "lucide-react";
import { useLang } from "@/lib/i18n";

export default function PromoStrip() {
  const { t } = useLang();
  const icons = [ShieldCheck, Clock, Award, Tag];
  return (
    <section
      data-testid="promo-strip"
      className="bg-brand-yellow border-y-2 border-yellow-500 relative"
    >
      <div className="container-max py-5 grid grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
        {t.trust.map((title, i) => {
          const Icon = icons[i] || ShieldCheck;
          return (
            <div key={title} className="flex items-start gap-3">
              <div className="shrink-0 w-10 h-10 rounded-xl bg-slate-900 text-brand-yellow flex items-center justify-center">
                <Icon size={18} />
              </div>
              <div className="leading-tight">
                <p className="font-heading font-bold text-slate-900 text-sm sm:text-[15px]">{title}</p>
                <p className="text-[11px] sm:text-xs text-slate-700 mt-0.5">{t.trustSub[i]}</p>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
